<ng-container [formGroup]="form">
  <ng-container [formGroupName]="controlName">
    <ng-container *ngIf="!mode || mode === 'select'; else editModeTemplate">
      <app-autocomplete-with-controls (onControlTriggered)="changeMode($event)"
                                      (onDropdownSearch)="handleAddressSearch($event)"
                                      [dropdownSearchEnabled]="dropdownSearchEnabled"
                                      [dropdownSearchDebounceTime]="0"
                                      [formControl]="formGroup.get('data')"
                                      [dropdownSearching]="false"
                                      [options]="filteredOptions$ | async"
                                      [transformFn]="transformFn"
                                      [config]="config"
                                      [controlsConfig]="controlsConfig"
                                      searchPlaceholder="Пошук"
                                      data-test-id="RecipientAddressSelect"
                                      class="form-row">
        <ng-template appAutocompleteOption let-option>
          {{ (option && option.CityDescription && option.AddressDescription ? createWarehouseDescription(option) : createDoorsDescription(option)) || '' }}
        </ng-template>
        <app-autocomplete-error>
          {{ getError(data, RecipientAddressErrors) }}
        </app-autocomplete-error>
      </app-autocomplete-with-controls>
    </ng-container>
    <ng-template #editModeTemplate>
      <np-inv-edit-container data-test-id="RecipientAddressCreate"
                             [controlName]="controlName"
                             [formTypeName]="controlTypeName"
                             [isCancelable]="!!options.length"
                             (onCancel)="cancel()"
                             (onClear)="clear()">
        <np-inv-type-radio-group data-test-id="RecipientAddressType"
                                 [formControlName]="CONTROL_NAMES.TYPE"
                                 [types]="types"
                                 (onTypeChanged)="onTypeChanged($event)"
                                 [modifyClass]="'radio-row_mr-top'">
        </np-inv-type-radio-group>

        <ng-container [ngSwitch]="activeType">
          <div class="wrapp-form">
            <app-warehouse *ngSwitchCase="AddressTypes.WAREHOUSE"
                           [cityClasses]="'form-col form-col-2'"
                           [warehouseClasses]="'form-col form-col-6'"
                           [form]="control"
                           [controlName]="CONTROL_NAMES.DATA"
                           [controlTypeName]="CONTROL_NAMES.TYPE"
                           class="shrink"></app-warehouse>

            <app-address *ngSwitchCase="AddressTypes.DOORS"
                         [form]="control"
                         [cityClasses]="'form-col form-col-2'"
                         [buildingClasses]="'form-col form-col-1'"
                         [controlName]="CONTROL_NAMES.DATA"
                         [controlTypeName]="CONTROL_NAMES.TYPE"
                         class="shrink"></app-address>

            <app-postbox *ngSwitchCase="AddressTypes.POSTBOX"
                         [cityClasses]="'form-col form-col-2'"
                         [warehouseClasses]="'form-col form-col-6'"
                         [form]="control"
                         [controlName]="CONTROL_NAMES.DATA"
                         [controlTypeName]="CONTROL_NAMES.TYPE"
                         class="shrink"></app-postbox>

            <app-store *ngSwitchCase="AddressTypes.STORE"
                       [cityClasses]="'form-col form-col-2'"
                       [warehouseClasses]="'form-col form-col-6'"
                       [form]="control"
                       [controlName]="CONTROL_NAMES.DATA"
                       [controlTypeName]="CONTROL_NAMES.TYPE"
                       class="shrink">
            </app-store>
          </div>
        </ng-container>
      </np-inv-edit-container>
    </ng-template>
  </ng-container>
</ng-container>
